import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IChatSampleQuestion } from '../../../../shared/interfaces/ai-chat.interface';
import { TranslateService } from '../../translate/translate.service';

@Component({
  selector: 'app-ai-chat-sample-questions',
  templateUrl: './ai-chat-sample-questions.component.html',
  styleUrl: './ai-chat-sample-questions.component.scss',
})
export class AiChatSampleQuestionsComponent implements OnInit {
  @Input() public count: number;
  @Output() public questionSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor(private translateService: TranslateService) {}

  private sampleQuestions: IChatSampleQuestion[] = [
    { key: 'ai_chat_sample_question_wcag_1_2_3' },
    { key: 'ai_chat_sample_question_mind_patterns' },
    { key: 'ai_chat_sample_question_wcag_purpose' },
    { key: 'ai_chat_sample_question_level_access_testing' },
    { key: 'ai_chat_sample_question_wcag_success_criteria' },
    { key: 'ai_chat_sample_question_wcag_guidelines' },
    { key: 'ai_chat_sample_question_wcag_1_2_4_captions' },
    { key: 'ai_chat_sample_question_react_native_dark_mode' },
    { key: 'ai_chat_sample_question_contrast_requirements' },
    { key: 'ai_chat_sample_question_header_landmark_testing' },
  ];

  public selectedSampleQuestions: string[] = [];

  ngOnInit(): void {
    this.generateSampleQuestions();
  }

  public refresh(): void {
    this.generateSampleQuestions();
  }

  private generateSampleQuestions(): void {
    // Translate only the questions that have been selected
    // and translating on init so do not need to translate on display and again on click
    this.selectedSampleQuestions = this.getRandomUniqueQuestions(this.count).map((question: IChatSampleQuestion) =>
      this.translateService.instant(question.key),
    );
  }

  private getRandomUniqueQuestions(count: number): IChatSampleQuestion[] {
    const questions: IChatSampleQuestion[] = [...this.sampleQuestions];

    if (count >= questions.length) {
      return questions;
    }

    const result: IChatSampleQuestion[] = [];
    for (let i: number = 0; i < count; i++) {
      const randomIndex: number = i + Math.floor(Math.random() * (questions.length - i));
      [questions[i], questions[randomIndex]] = [questions[randomIndex], questions[i]];
      result.push(questions[i]);
    }

    return result;
  }

  public onQuestionClick(question: string): void {
    this.questionSelected.emit(question);
  }
}
